import { Injectable } from '@angular/core';

@Injectable()
export class NonAuthService {
  resetDataObj: any = {};

  constructor() { }

  setData(dataObj: any) {
    Object.assign(this.resetDataObj, dataObj);
  }

  getData() {
    return this.resetDataObj;
  }

  resetData() {
    this.resetDataObj = {};
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/non-auth/non-auth.service.ts